<template>
  <v-card
    border
    class="pa-5 no-focus"
  >
    <div class="d-flex align-center">
      <div class="pb-0 d-flex w-full flex-md-row flex-column">
        <router-link
          to="/content-creator"
          class="text-decoration-none"
        >
          <div class="d-flex align-center flex-grow-0 mr-4">
            <v-icon
              class="static-gradient-background statistic-icon rounded-circle pa-7 mr-4"
              color="white"
              size="x-large"
              style="font-size: 40px"
            >
              mdi-share-outline
            </v-icon>
            <span class="text-h6 text-h5 text-grey font-weight-light">{{
              $t('labels.statistics.content-creator')
            }}</span>
          </div>
        </router-link>

        <div
          class="flex-grow-1 d-flex align-center justify-space-around flex-column flex-md-row mt-4 mt-md-0"
        >
          <StatisticValue
            :loading="!savedContents"
            :title="$t('content-creator.dashboard.contents')"
            :value="savedContents?.total"
          />
          <StatisticValue
            :loading="!savedContents"
            :title="$t('content-creator.dashboard.contact-points')"
            :value="savedContents?.numberOfPosts"
          />
          <StatisticValue
            :loading="!savedContents"
            :title="$t('content-creator.dashboard.time')"
            :value="timeSaved"
          />
          <StatisticValue
            :loading="!savedContents"
            :title="$t('content-creator.dashboard.money')"
            :value="moneySaved"
          />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import currency from '@/mixins/currency'
import feature from '@/mixins/feature'

import GET_SAVED_CONTENTS from './getSavedContents.gql'
import StatisticValue from './StatisticValue.vue'
const MINUTES_PER_POST = 45
const MONEY_PER_MINUTE = 2.5

export default {
  components: {
    StatisticValue,
  },
  mixins: [feature, currency],
  computed: {
    factors() {
      const dashboardConfig = this.$features.feature(this.featureNames.CONTENT_CREATOR)?.config
        ?.dashboard
      const minutesPerPost = dashboardConfig?.minutesPerPost
      const moneyPerMinute = dashboardConfig?.moneyPerMinute
      return {
        minutesPerPost: minutesPerPost || MINUTES_PER_POST,
        moneyPerMinute: moneyPerMinute || MONEY_PER_MINUTE,
      }
    },
    timeSaved() {
      return (
        this.savedContents?.total &&
        this.formatTime(this.savedContents?.total * this.factors.minutesPerPost)
      )
    },
    moneySaved() {
      return (
        this.savedContents?.total &&
        this.formatPrice(
          this.savedContents?.total * this.factors.minutesPerPost * this.factors.moneyPerMinute
        )
      )
    },
  },
  methods: {
    formatTime(minutes) {
      return `${Math.round(minutes / 60)} h`
    },
  },
  apollo: {
    savedContents: {
      query: GET_SAVED_CONTENTS,
      variables() {
        return {
          input: {
            perPage: 1,
            page: 1,
          },
        }
      },
    },
  },
}
</script>
<style scoped>
.statistic-icon {
  width: 32px;
  height: 32px;
}
</style>
